module.exports = __webpack_public_path__ + "static/img/icon_create.806daa68.png";